import styled from 'styled-components';
import Dialog from '@material-ui/core/Dialog';

export const DialogStyled = styled(Dialog)`
  .MuiDialogContent-root:first-child {
    padding-top: 30px;
  }
  .MuiDialogActions-root {
    padding: 8px 24px 20px;
  }

  .dialog {
    &__close-btn {
      position: absolute;
      top: 5px;
      right: 5px;
    }

    &__price-field {
      display: flex;
      align-items: center;

      > :not(:last-child) {
        margin-right: 15px;
      }
    }
  }
`;

export default DialogStyled;
